<template>
  <div class="tableClass">
    <!-- grid + 分页 -->
    <el-table
      :data="gridData"
      :size="gridConfig.size"
      :border="gridConfig.border"
      style="width:100%"
      :height="height"
      :stripe="gridConfig.stripe"
      v-loading="gridConfig.loading"
      :show-header="gridConfig.showHeader"
      @row-click="rowClick"
      @sort-change="sortChange"
      @selection-change="handleSelectionChange"
      :span-method="gridConfig.arraySpanMethod"
      :show-summary="gridConfig.showSummary"
      :summary-method="gridConfig.summaryMethod"
      highlight-current-row
      :row-style="rowStyleFunc?rowStyleFunc:selectedHighlight"
      :ref="tableRef"
      :max-height="maxHeight"
      @current-change="currentRowChange"
    >
      <el-table-column v-if="gridConfig.multiSelect" type="selection" align="center"
                       width="50"></el-table-column>
      <el-table-column type="expand" v-if="gridConfig.showExpand">
        <template slot-scope="props">
          <slot name="expand" :data="props.row"></slot>
        </template>
      </el-table-column>
      <el-table-column v-if="gridConfig.hasIndex" type="index" align="center" :index="indexMethod"
                       label="序号"
                       width="55"></el-table-column>
      <mx-column v-if="gridColumns && gridColumns.length > 0 " v-for="(column, index) in gridColumns" :column="column"
                 :key="index"></mx-column>
    </el-table>
    <!-- 分页 -->
    <!-- 会员服务分页 -->
    <div class="bottom-pagination" v-if="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="currentChange"
        :current-page="pagination.page"
        :page-sizes="pagination.sizes || [100,200,500,1000]"
        :page-size="pagination.size"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import MxColumn from './column'

export default {
  components: {
    MxColumn
  },
  emits: ['current-row-change'],
  data() {
    return {
      selection: [],
      // 旧的高亮行
      oldRow: ''
    }
  },
  props: {
    tableRef: {
      type: String,
      default: 'mxTable'
    },
    gridData: {
      type: Array
    },
    gridConfig: {
      type: Object
    },
    gridColumns: {
      type: Array
    },
    pagination: {
      type: Object
    },
    fetch: {
      type: Function
    },
    /* ***** 父组件是子组件时，table的高度 ******/
    dashboardHeight: {
      type: Number,
      default: 0
    },
    rowStyleFunc: {
      type: Function
    },
    headStyleFunc: {
      type: Function
    },
    maxHeight: {
      type: Number
    }
  },
  watch: {
    // 深度监听，可监听到对象、数组的变化
    gridColumns: {
      handler(val, oldVal) {
        this.$refs[this.tableRef].doLayout()
      },
      // true 深度监听
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'mainDOMRect'
    ]),
    mainHeight() { // main区域高度
      return this.mainDOMRect.height
    },
    height: { // grid 的高度
      get() { // 回调函数 当需要读取当前属性值是执行，根据相关数据计算并返回当前属性的值
        if (this.dashboardHeight > 0) {
          return this.dashboardHeight
        } else {
          if (this.gridConfig.autoHeight) {
            return null
          }
          if (this.gridConfig.isHeaderExist) { // 如果表格存在头部（搜索框、按钮行）
            if (this.gridConfig.topHeight > 0) {
              return this.mainHeight - 223 - this.gridConfig.topHeight
            }
            return this.mainHeight - 223
          } else {
            if (this.gridConfig.topHeight > 0) {
              return this.mainHeight - 163 - this.gridConfig.topHeight
            }
            return this.mainHeight - 163
          }
        }
      },
      set() {
      }
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs[this.tableRef].doLayout()
    })
  },
  mounted() {
    this.$parent.gridConfig = Object.assign({
      size: 'mini',
      border: true,
      stripe: true,
      loading: false,
      multiSelect: true,
      hasIndex: true,
      showHeader: true,
      isHeaderExist: true,
      showExpand: false, // 是否开启展开行
      topHeight: 0, /* ** table距离 按钮、搜索栏中间的高度 **/
      initTable: true, // 是否页面一启动就加载数据
      autoHeight: true // 自动高度
    }, this.gridConfig)
    this.gridConfig.initTable && this.fetch()
  },
  methods: {
    setOldCurrentRow() {
      if (this.oldRow) {
        this.$refs[this.tableRef].setCurrentRow(this.oldRow)
      }
    },
    currentRowChange(news, old) {
      this.oldRow = old
    },
    indexMethod(index) {
      if (this.pagination) {
        return (this.pagination.page - 1) * this.pagination.size + index + 1
      } else {
        return index + 1
      }
    },
    sortChange({column, prop, order}) {
      this.$emit('sort-change', {column, prop, order})
    },
    rowClick(row, column, event) {
      this.$emit('row-click', {row, column, event})
    },
    handleSelectionChange(selection) {
      this.selection = selection
      this.$emit('selection-change', selection)
    },
    handleSizeChange(size) {
      this.pagination.size = size
      this.pagination.page = 1
      this.fetch()
    },
    currentChange(currentChange) {
      this.pagination.page = currentChange
      this.fetch()
    },
    selectedHighlight({row, rowIndex}) {
      if (this.selection.includes(row)) {
        return {'background-color': '#d9ecff'}
      }
    }

  }
}
</script>
<style lang="scss" scoped>
.tableClass {
  .el-table th {
    background: #E4E7ED !important;
  }

  .el-table--border th.gutter:last-of-type {
    border-bottom: 1px solid #ebeef5;
    border-bottom-width: 1px;
    border-right: 0px;
    background: #fff !important;
  }

  // 单元格图片间距
  .el-table {
    .el-table__body {
      .el-table__row {
        .cell {
          img + img {
            margin-left: 10px !important;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Table/MxTable/index.vue